import React, { useState } from "react";
import styles from "./LoginModal.module.css";
import SignUpModal from "./SignUpModal";
import { useDispatch } from "react-redux";
import { updateInfoAndCloseModal } from "../slice/userInfoSlice";
import axios from "axios";
import { DEV_API } from "../Common/Constant";
import { useNavigate } from "react-router-dom";
import ForgotPWModal from "./ForgotPwModal";
import PasswordInput from "../CustomComp/pswdInput/PasswordInput";

const initFormData = {
  email: "",
  password: "",
  mobile: "",
  otp: "",
}

const LoginModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isUsingEmail, setIsUsingEmail] = useState(false);
  const [useOTP, setIsUsingOTP] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [toggleForgotPw, setForgotPw] = useState(false);
  const [loginErr, updateLoginError] = useState("");
  const [formData, setFormData] = useState(initFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleForgetPswd = () => {
    setForgotPw(false);
  }

  const onFormSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let reqq = {};
    const { email, password, mobile } = formData;
    reqq = isUsingEmail ? { email, password } : { mobile, password };
    if (!isUsingEmail && useOTP) {
      reqq = { mobile, password };
    }
    let req = { ...formData };
    isUsingEmail ? delete req.mobile : delete req.email;
    axios
      .post(`${DEV_API}/users/login`, req)
      .then((res) => {
        if (res?.data?.success) {
          const authHeader = res.headers["authorization"];
          if (authHeader) {
            const token = authHeader.replace("Bearer ", ""); // remove Bearer prefix if present
            // Optionally, store it in localStorage
            window.localStorage.setItem("token", token);
            dispatch(updateInfoAndCloseModal(res?.data?.user));
            navigate("/home");
          } else {
            updateLoginError("Auth Not Found");
          }
        }
      })
      .catch((err) => {
        console.error("err----", err?.response?.data?.error);
        updateLoginError(err?.response?.data?.error);
      });
  };

  if (isSignUp) return <SignUpModal onBack={() => setIsSignUp(false)} />;

  if(toggleForgotPw) return <ForgotPWModal toggleForgetPswd={toggleForgetPswd}/>

  const toggleOtp = () => {
    setIsUsingOTP(!useOTP);
  };

  const toggleMail = () => {
    setIsUsingEmail(!isUsingEmail);
    setIsUsingOTP(false);
  };

  const onForgotPassword = () => {
    setForgotPw(true);
  }

  const toggleSignUpModal = () => {
    setIsSignUp(true);
    setFormData(initFormData);
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.loginHeader}>
        <h2 className="m0">Login</h2>
        </div>

        <form onSubmit={onFormSubmit} className={styles.form}>
          {isUsingEmail ? (
            <>
              <div className={styles.formGroup}>
                <div className={styles.labelWithBtn}>
                  <label>Email</label>
                  <span className={styles.toggle} onClick={toggleMail}>
                    Use Mobile No
                  </span>
                </div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <div className={styles.labelWithBtn}>
                  <label>Password</label>
                  <span className={styles.toggle} onClick={onForgotPassword}>
                    Forgot Password?
                  </span>
                </div>
                <PasswordInput
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
            </>
          ) : (
            <>
              <div className={styles.formGroup}>
                <div className={styles.labelWithBtn}>
                  <label>Mobile Number</label>
                  <span className={styles.toggle} onClick={toggleMail}>
                    Use Email id
                  </span>
                </div>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>
              {!useOTP && (
                <div className={styles.formGroup}>
                  <div className={styles.labelWithBtn}>
                    <label>
                      Password
                      {/* <span
                        className={styles.toggle}
                        onClick={onForgotPassword}
                      >
                        Forgot Password?
                      </span> */}
                    </label>
                    <span
                        className={styles.toggle}
                        onClick={onForgotPassword}
                      >
                        Forgot Password?
                      </span>
                    {/* <span className={styles.toggle} onClick={toggleOtp}>
                      Use OTP
                    </span> */}
                  </div>
                  <PasswordInput
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
                </div>
              )}
              {useOTP && (
                <div className={styles.formGroup}>
                  <div className={styles.labelWithBtn}>
                    <label>OTP</label>
                    <span className={styles.toggle} onClick={toggleOtp}>
                      Use Password
                    </span>
                  </div>
                  <input
                    type="text"
                    name="otp"
                    value={formData.otp}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </>
          )}
          {loginErr && <div className={styles.loginError}>{loginErr}</div>}
          <button type="submit" className={styles.submitButton}>
            Log In
          </button>
        </form>

        <div className={styles.footer}>
          Not an existing user?{" "}
          <button onClick={toggleSignUpModal} className={styles.toggle}>
            Click for Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
